import ApiClient from '@/api/ApiClient';

const ROUTE = 'agency/unavailability';
const client = new ApiClient(ROUTE);

class UnavailabilityApiAgency {

	static listByUserId (userId: number) {
		return client.get<IUnavailabilityModel[]>(`user/${userId}`);
	}
}

export default UnavailabilityApiAgency;
